import { clsx } from 'clsx';
import { Box } from '@material-ui/core';

import useStyles from './CustomMinusButton.styles';

export function CustomMinusButton({ disabled, onClick, classes = {} }) {
  const _classes = useStyles({ disabled });

  return (
    <Box
      aria-label='Minus'
      className={clsx(_classes?.button, classes?.button)}
      disabled={disabled}
      onClick={disabled ? null : onClick}
    >
      <span className={clsx(_classes.icon, classes?.icon)}>-</span>
    </Box>
  );
}
